import type { UserContextRbacPermission } from 'core/userContext/types';
import { ProjectPermission } from 'modules/domains/project';
import { MessageMedium } from 'modules/graphql';

// Maps the const enum from the domain to the original record we had.
export const PROJECT_PERMISSIONS = {
  DraftMessaging: ProjectPermission.DraftMessaging,
  EmailChannel: ProjectPermission.EmailChannel,
  EmbeddedChannel: ProjectPermission.EmbeddedChannel,
  PushInAppChannel: ProjectPermission.PushInAppChannel,
  ManageBaseTemplates: ProjectPermission.ManageBaseTemplates,
  ManageCatalogs: ProjectPermission.ManageCatalogs,
  ManageChannelConfiguration: ProjectPermission.ManageChannelConfiguration,
  ManageGoals: ProjectPermission.ManageGoals,
  ManageIntegrations: ProjectPermission.ManageIntegrations,
  ManageMessaging: ProjectPermission.ManageMessaging,
  ManageProjectSettings: ProjectPermission.ManageProjectSettings,
  ManageReports: ProjectPermission.ManageReports,
  ManageSegmentation: ProjectPermission.ManageSegmentation,
  ManageSnippets: ProjectPermission.ManageSnippets,
  ManageUserProfiles: ProjectPermission.ManageUserProfiles,
  PushChannel: ProjectPermission.PushChannel,
  SMSChannel: ProjectPermission.SMSChannel,
  ViewAndExportUserData: ProjectPermission.ViewAndExportUserData,
  ViewCatalogs: ProjectPermission.ViewCatalogs,
  ViewChannelConfiguration: ProjectPermission.ViewChannelConfiguration,
  ViewGoals: ProjectPermission.ViewGoals,
  ViewMessaging: ProjectPermission.ViewMessaging,
  ViewReports: ProjectPermission.ViewReports,
  PushWebChannel: ProjectPermission.PushWebChannel,
  CampaignMediumsGroup: ProjectPermission.CampaignMediumsGroup,
  WhatsAppChannel: ProjectPermission.WhatsAppChannel,
};

export const ORG_PERMISSIONS = {
  CreateProjects: 10,
  ManageBilling: 7,
  ManageMembers: 15,
  ManageRoles: 19,
};

/**
 * map a message medium to a permission id
 */
export const PERMISSIONS_BY_MESSAGE_MEDIUM = {
  Email: PROJECT_PERMISSIONS.EmailChannel,
  InApp: PROJECT_PERMISSIONS.PushInAppChannel,
  SMS: PROJECT_PERMISSIONS.SMSChannel,
  Push: PROJECT_PERMISSIONS.PushChannel,
  WebPush: PROJECT_PERMISSIONS.PushWebChannel,
  Embedded: PROJECT_PERMISSIONS.EmbeddedChannel,
  WhatsApp: PROJECT_PERMISSIONS.WhatsAppChannel,
};

export const doesRbacPermissionHaveAccess = (
  userContextRbacPermissions: UserContextRbacPermission[],
  requestedPermission: UserContextRbacPermission | UserContextRbacPermission[],
) =>
  Array.isArray(requestedPermission)
    ? requestedPermission.every((p) => userContextRbacPermissions.includes(p))
    : userContextRbacPermissions.includes(requestedPermission);

/**
 * Utility function specific to ManageMessaging, based on feature flag and message medium
 */
export const canManageMessagingByMedium = (
  userPermissions: number[],
  messageMedium: MessageMedium | undefined,
  featureFlag = false,
) => {
  const permission =
    featureFlag && !!messageMedium
      ? PERMISSIONS_BY_MESSAGE_MEDIUM[messageMedium]
      : PROJECT_PERMISSIONS.ManageMessaging;
  return doesRbacPermissionHaveAccess(userPermissions, permission);
};
